import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransferAgentIntegrationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto,
} from '../../services/wealthlane-award-services';

const useGetActiveTransferAgent = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_TransferAgents_ActiveTransferAgentIntegrationDto | undefined,
  unknown
> => {
  const activeTransferAgent = useQuery(['getActiveTransferAgent'], async () => {
    return await handleRequest(
      TransferAgentIntegrationService.getApiAwardApiAppTransferAgentActiveTransferAgentIntegration()
    );
  });

  return activeTransferAgent;
};

export default useGetActiveTransferAgent;
